// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__hfaVY","resendInfoText":"OnGoingPaymentBox_resendInfoText__Lf7Nd"};